import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  locationNameFromModel,
  validateLocationNameCondition,
  type LocationNameState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const LOCATION_NAME = (
  Details: React.ComponentType<ConditionTypeDetailsProps<LocationNameState>>,
): ConditionType<LocationNameState, Condition.LocationName> => ({
  name: CONDITION_NAMES[Condition.LOCATION_NAME],
  description(state) {
    if (state.names.length === 0) {
      return t("No locations selected");
    }
    if (state.names.length === 1) {
      return t('Origin location is "{{name}}"', { name: state.names[0] });
    }
    return t("Origin location is one of: {{names}}", {
      names: state.names.join(", "),
    });
  },
  Details(props: ConditionTypeDetailsProps<LocationNameState>) {
    return React.createElement(Details, props);
  },
  empty: { names: [] },
  fromModel(model) {
    return locationNameFromModel(model);
  },
  toModel(state) {
    return { type: Condition.LOCATION_NAME, names: state.names };
  },
  valid(state) {
    return validateLocationNameCondition(state).valid;
  },
});
